<dx-tab-panel #tabPanel
              [dataSource]="pages"
              [selectedIndex]="0"
              [loop]="false"
              [animationEnabled]="true"
              [swipeEnabled]="true">
  <div *dxTemplate="let temp of 'uploadTemplate'">
    <div class="dx-fieldset">
      <div class="dx-field">
        <dx-file-uploader #fileUploader
                          name="file"
                          uploadUrl="api/import/ImportCatalogChunky"
                          [uploadHeaders]="uploadHeaders"
                          [multiple]="false"
                          [chunkSize]="10000000"
                          [accept]="fileTypes"
                          uploadMode="instantly"
                          (onBeforeSend)="onBeforeSendUpload($event)"
                          (onProgress)="onProgress($event)"
                          (onUploaded)="onUploaded()"
                          invalidFileExtensionMessage="{{ 'Bitte nur xml zip xlsx xls oder csv Dateien auswählen' | translate }}."
                          invalidMaxFileSizeMessage="{{ 'Die Datei ist leider zu groß' | translate }}"
                          invalidMinFileSizeMessage="{{ 'Die Datei ist leider zu klein' | translate }}"
                          selectButtonText="{{ 'Datei auswählen' | translate }}"
                          labelText="{{ 'oder Datei hier ablegen' | translate }}"
                          uploadButtonText="{{ 'Upload' | translate }}"
                          uploadedMessage="{{ 'Hochgeladen' | translate }}"
                          uploadFailedMessage="{{ 'Hochladen fehlgeschlagen' | translate }}">
        </dx-file-uploader>
      </div>
    </div>
  </div>

  <div *dxTemplate="let temp of 'linkTemplate'">
    <div class="dx-fieldset">
      <div class="dx-field">
        <div class="{{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }} w-100" id="uc1" (mouseenter)="uct(1)" (mouseleave)="uct(1)">
          <label class="placeLabel {{ fileUrl?.length>0 ? 'placeLabelSmall' : '' }}">CATALOG_URL</label>
          <dx-text-box [(value)]="fileUrl" [showClearButton]="true" (onValueChanged)="linkChanged($event)"></dx-text-box>
        </div>

        <dx-tooltip target="#uc1" class="toolTip toolTipField" [(visible)]="c[1]">
          <div *dxTemplate="let data = data of 'content'">
            {{ 'Hier können Sie einen Link zu einer Katalogdatei eintragen, um diesen zu importieren' | translate }}
            {{ 'Es werden zum Beispiel Links zu Dateien in einer Dropbox unterstützt oder Links, welche aus anderen Systemen erstellt wurden' | translate }}.
            {{ 'Bsp' | translate }}.: https://www.dropbox.com/s/h5pldo0u8h7qkje/mediaFile.zip?dl=0
          </div>
        </dx-tooltip>
      </div>

      <div *ngIf="fileUrl.length>0">
        <div *ngIf="!fileUrlTest">
          <div style="color: red;">
            {{fileUrlTestMessage}}
          </div>
        </div>
      </div>

    </div>

    <dx-toolbar *ngIf="fileUrl.length>0">
      <dxi-item *ngIf="!fileUrlTest" location="before" widget="dxButton" [options]="{ type: 'default', text: 'Link testen' | translate, onClick: testLink }"></dxi-item>
      <dxi-item *ngIf="fileUrlTest" location="before" widget="dxButton" [options]="{ type: 'default', text: 'Katalog laden' | translate, onClick: startDownload }"></dxi-item>
    </dx-toolbar>

  </div>

  <div *dxTemplate="let temp of 'osgTemplate'">
    <div class="dx-fieldset">
      <div class="dx-field" *ngIf="hasOsgTestSystem">
        <div class="dx-field-label">{{ 'Testsystem verwenden' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch [(value)]="useTest" switchedOffText="{{ 'Live' | translate }}" switchedOnText="{{ 'Test' | translate }}"></dx-switch>
        </div>
      </div>


      <div class="dx-field">
        <div class="dx-field-label">{{ 'Sortiment' | translate }}</div>
        <div class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
          <label class="placeLabel {{ productRange !=null ? 'placeLabelSmall' : '' }}">PRODUCT_RANGE</label>
          <dx-select-box [(value)]="productRange"
                         [items]="productRanges"
                         [grouped]="false"
                         [searchEnabled]="true"
                         noDataText="{{ 'Kein Sortiment gefunden.' | translate }}"
                         placeholder=""></dx-select-box>
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label">{{ 'Wurzelkategorie ignorieren' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch [(value)]="keepRootCategory" switchedOffText="{{ 'Nein' | translate }}" switchedOnText="{{ 'Ja' | translate }}"></dx-switch>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Warengruppen Sortimentsunabhängig' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch [(value)]="takeAllCategory" switchedOffText="{{ 'Nein' | translate }}" switchedOnText="{{ 'Ja' | translate }}"></dx-switch>
        </div>
      </div>

    </div>

    <dx-toolbar *ngIf="productRange">
      <dxi-item  location="before" widget="dxButton" [options]="{ type: 'default', text: 'Katalog laden' | translate, onClick: osgCreateJob }"></dxi-item>
    </dx-toolbar>

  </div>

  <div *dxTemplate="let temp of 'edcTemplate'">
    <dx-toolbar>
      <dxi-item location="before" widget="dxButton" [options]="{ type: 'default', text: 'Edc Katalog laden' | translate, onClick: edcImport }"></dxi-item>
    </dx-toolbar>
  </div>

</dx-tab-panel>





